import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import intervalPlural from 'i18next-intervalplural-postprocessor'
import { initReactI18next } from 'react-i18next'

import localesDE from '../locales/de/translation.json'
import localesEN from '../locales/en/translation.json'
import localesFR from '../locales/fr/translation.json'
import localesPL from '../locales/pl/translation.json'

export const i18nConfig = {
  resources: {
    en: {
      translation: localesEN,
    },
    de: {
      translation: localesDE,
    },
    fr: {
      translation: localesFR,
    },
    pl: {
      translation: localesPL,
    },
  },
  fallbackLng: 'en',
  // Resources are bundled inline (no async backend), so we can initialise
  // synchronously. This guarantees `i18n.resolvedLanguage` is populated
  // immediately at module-load time — before the Pisa data classes read it
  // to build the `Accept-Language` header. With the default `initImmediate:
  // true` the language is still `undefined` on the first (memoized) request,
  // which silently fell back to 'en' in the deployed build.
  initImmediate: false,
  interpolation: {
    escapeValue: false,
  },
}

// false eslint warning https://github.com/i18next/i18next/issues/1035
// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(intervalPlural)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init(i18nConfig)
